import React from 'react';

import UnfollowUser from '@src/api/UnfollowUser';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useIsMounted from '@src/hooks/useIsMounted';

const useUnfollowUser = () => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();
  const isMounted = useIsMounted();
  const [loading, setLoading] = React.useState(false);

  const request = React.useCallback(
    async (userId: string) => {
      try {
        setLoading(true);
        await UnfollowUser(userId, accessToken, axiosRequestConfig);
      } catch (e) {
        axiosErrorHandler(e);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    },
    [accessToken, axiosErrorHandler, axiosRequestConfig, isMounted]
  );

  return React.useMemo(() => ({ request, loading }), [loading, request]);
};

export default useUnfollowUser;
